import { Link, Text } from '@doist/marketist';
import { useCloudinaryImageLocal } from 'services/hooks/use-cloudinary-local';
import { Image } from '../image/image';
import css from './tip-card.module.css';
type TipCardLink = {
  text: string;
  href: string;
  target: string;
};
export type TipCardProps = {
  title: string;
  description: string;
  ctaLink?: TipCardLink;
  captionLink?: TipCardLink;
  backgroundImage?: {
    url: string;
    alt?: string;
  };
};
export function TipCard({
  title,
  description,
  ctaLink,
  captionLink,
  backgroundImage
}: TipCardProps) {
  const containerBackgroundImage = useCloudinaryImageLocal(`${process.env.NEXT_PUBLIC_BASE_URL}/static/productivitymethods/promotion-card-bg.jpg`);
  return <div className={css.tipCard} style={{
    '--tip-card-bg-image': `url(${containerBackgroundImage})`
  }} data-sentry-component="TipCard" data-sentry-source-file="tip-card.tsx">
            <Text size="major-base" data-sentry-element="Text" data-sentry-source-file="tip-card.tsx">{title}</Text>
            <Text size="body-sm" data-sentry-element="Text" data-sentry-source-file="tip-card.tsx">{description}</Text>
            {ctaLink && <Link className={css.ctaLink} href={ctaLink.href} target={ctaLink.target}>
                    {ctaLink.text}
                </Link>}
            {captionLink && <Link className={css.captionLink} href={captionLink.href} target={captionLink.target}>
                    {captionLink.text}
                </Link>}
            {backgroundImage && <Image src={backgroundImage.url} alt={backgroundImage.alt ?? ''} width={320} height={154} />}
        </div>;
}